export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8005.00656e47.jpg";